// Generated by CoffeeScript 1.3.3
(function() {
  var Singleton;

  Singleton = (function() {

    function Singleton() {}

    Singleton.get = function() {
      var _ref;
      return (_ref = this.instance) != null ? _ref : this.instance = new this;
    };

    return Singleton;

  })();

  module.exports = Singleton;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/singleton/lib/singleton.js
// module id = 904
// module chunks = 0